// The pages a pager's capsule shows — brief §4.5 item 6 (P25, P31): the
// first and the last page, and the current page with two on each side, so
// never more than 7 chips; ascending, and a gap in the numbers shows the
// skipped pages. Lifted from the /data pager (workspace 77a1efbae, its
// `_pageWindow`) into the kit, so every AppPagination windows the same way
// and a page with its own state shape can reuse it:
//
//   el.call('appPageWindow', page, pageCount)  // → [1, 8, 9, 10, 11, 12, 20]
//
// `page` is clamped into 1..pageCount, so a stale page never drops the
// current chip out of the window.
export function appPageWindow(page, pageCount) {
  const total = Math.max(1, Math.floor(Number(pageCount) || 1))
  const cur = Math.min(total, Math.max(1, Math.floor(Number(page) || 1)))
  const pages = new Set([1, total])
  for (let p = cur - 2; p <= cur + 2; p++) if (p >= 1 && p <= total) pages.add(p)
  return [...pages].sort((a, b) => a - b)
}
